export function leadDisplayLabel({
  firstName,
  lastName,
  name,
  email,
  phoneNumber,
}: {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
}): string {
  const fromParts = [firstName, lastName]
    .map((s) => (s ?? "").trim())
    .filter(Boolean)
    .join(" ");
  const trimmedName = (name ?? "").trim();
  const primary = fromParts || trimmedName;
  const emailTrim = (email ?? "").trim();
  const phoneTrim = (phoneNumber ?? "").trim();

  if (primary && emailTrim) return `${primary} (${emailTrim})`;
  if (primary && phoneTrim) return `${primary} (${phoneTrim})`;
  if (primary) return primary;
  if (emailTrim) return emailTrim;
  if (phoneTrim) return phoneTrim;
  return "Unnamed contact";
}

export function isNamedLead({
  firstName,
  lastName,
  name,
  email,
  phoneNumber,
}: {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
}): boolean {
  const fromParts = [firstName, lastName]
    .map((s) => (s ?? "").trim())
    .filter(Boolean)
    .join(" ");
  const trimmedName = (name ?? "").trim();
  const primary = fromParts || trimmedName;
  return Boolean(
    primary || (email ?? "").trim() || (phoneNumber ?? "").trim(),
  );
}
